import { useEffect, useCallback, useState } from 'react';

import { Box, Grid, Button, CircularProgress, FormControlLabel, Checkbox } from '@mui/material';
import { SelectField, TextField, DateTimePicker, MultilineField, Dialog } from 'style-guide';

import ReportIcon from '@mui/icons-material/Report';
import TocIcon from '@mui/icons-material/Toc';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
const CustomsUIError = ({ data, details, orgData }) => {

    const filter = (d) => {
        if (d.field != "lines" && d.field != "shipper_address" && d.field != "consignee_address")
            return true;
        return false;
    }
    const getVal = (val) => {
        var type = typeof val
        if (type === "string") {
            return val.slice(0, 20);
        }
        if (!val)
            return "N/A";
        return val;
    }
    const showJsonInNewTab = (cellData) => {
        const jsonString = JSON.stringify(orgData.fileData[cellData], null, 2);
        //const jsonString = JSON.stringify(data, null, 2);
        const newWindow = window.open();
        newWindow.document.open();
        newWindow.document.write(`<html><body><pre>${jsonString}</pre></body></html>`);
        newWindow.document.close();
    };
    const [showErrors, setShowErrors] = useState(null);
    const closeShowErrors = () => {
        setShowErrors(false);
    }
    const openShowErrors = () => {
        setShowErrors(true);
    }
    const [showErrorItems, setShowErrorItems] = useState(null);
    const [showErrorTitle, setShowErrorTitle] = useState(null);
    const showErrorsInNewTab = (cellData) => {
        var cdata = cellData.replace("_extracted.json", ".pdf");
        var dts = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i][0] === cdata) {
                dts.push(data[i][1]);
            }
        }
        openShowErrors();
        setShowErrorTitle(cdata);
        setShowErrorItems(dts);
    };
    const getBackgroudColorFromGrid = (row, label) => {
        if (row == 1) {
            for (var i = 0; i < data.length; i++) {
                if (data[i][2]?.includes("Consignee")) {
                    return "#fff0f0";
                }
            }
            return "#eaf7ef";
        }
        if (row == 2 || row == 3) {
            for (var i = 0; i < data.length; i++) {
                if (data[i][2]?.includes("Package count mismatch")) {
                    return "#fff0f0";
                }
            }
            return "#eaf7ef";
        }
        if (row == 4 || row == 5) {
            for (var i = 0; i < data.length; i++) {
                if (data[i][2]?.includes("Gross weight deviation")) {
                    return "#fff0f0";
                }
            }
            return "#eaf7ef";
        }
        if (row > 5) {
            if ((!label))
                return "#fbfcfd";
            if (typeof label === "string" && label?.toLowerCase() === "unknown")
                return "#fbfcfd";
        }
        return "#fbfcfd";
    }
    const getRowStyle = (index) => {
        if (index === 0) {
            return {
                backgroundColor: '#fbfdff',
                color: '#174f7c',
                fontWeight: 'bold'
            };
        }
        if (index === 1) {
            return {
                background: "linear-gradient(#f9fcfe, #eef5fa)",
                color: '#315a78',
                fontWeight: 'bold'
            };
        }
        return {
            backgroundColor: "#fbfcfd",
            color: '#000000'
        };
    };

    const getCellLabel = (cell, row, label) => {
        if (row == 0)
            return getVal(label);
        /*if (cell == 1) {
            var bg = getBackgroudColorFromGrid(row, label);
            if (bg === "#eaf7ef")
                return "MATCH";
            if (bg === "#fbfcfd" || bg === "#eee")
                return "";
            return "DIFFERENT";
        }*/
        return getVal(label);
    }

    const getCellStyle = (cell, row, label) => {
        if (cell === 0) {
            return {
                border: '1px solid #e3ebf0',
                padding: '12px',
                textAlign: 'left',
                maxWidth: '250px',
                overflow: "hidden",
                textOverflow: 'ellipsis',
                fontWeight: "bold",
                background: "#fbfcfd"
            };
        }
        return {
            border: '1px solid #e3ebf0',
            padding: '12px',
            textAlign: 'left',
            maxWidth: '250px',
            overflow: "hidden",
            textOverflow: 'ellipsis',
            background: getBackgroudColorFromGrid(row, label),
        }
    };
    const cellStyleHeader = {
        border: '1px solid #e3ebf0',
        padding: '10px',
        textAlign: 'left'
    };

    const [showPartial, setShowPartial] = useState(false);
    return (
        <Grid item container style={{ fontSize: "14px" }} lg={12} flexWrap="nowrap">
            {showErrors && <Dialog maxWidth='100vw' width="1600px" open={showErrors} onHandleCancel={closeShowErrors} title={showErrorTitle}>
                <Grid item container>
                    <ul>
                        {showErrorItems.map( item =>
                            <li>
                                {item}
                            </li>
                        )}
                    </ul>
                </Grid>
            </Dialog>}
            <Grid item container style={{ }} lg={3}>
                <div style={{ width: "100%", maxHeight: "530px", display: "block", overflowY: "auto" }}>
                    <table style={{ padding: "5px", textAlign: "center", border: "1px solid #dce5ec", borderRadius: "9px" }}>
                        <thead>
                            <tr>
                                <td style={{
                                    height: "30px", borderBottom: "1px solid #dce5ec", backgroundColor: "#fbfdff", textAlign: "left"
                                }}>
                                    <Grid item container>
                                        <p style={{ padding: "5px", margin: 0, fontWeight: "bold", color: "#174f7c" }}>Validation Summary</p>
                                    </Grid>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map(err => (<>{err[0] === "Cross Check" && <tr style={{ height: "35px", maxHeight: "35px" }}>
                                <td style={{ height: "30px", background: "white", textAlign: "left", borderBottom: "1px solid #edf2f5" }}>
                                    <Grid item container flexWrap="nowrap" flexDirection="column" style={{ padding: "10px" }}>
                                        <b style={{ margin: 0, padding: 0, color: "#c53b3b" }} title={err[2]}>{err[0]}</b>
                                        <p title={err[2]} style={{ marginTop: "5px", wordBreak: "break-all", color: "#708191", fontSize: "12px" }}>
                                            {err[1]}
                                        </p>
                                    </Grid>
                                    {/*<p style={{ margin: "5px", wordBreak: "break-all" }} title={err[2]}>
                                        <span style={{ fontWeight: "bold" }}>{err[0]}</span>: <span>{err[1]}</span>
                                    </p>*/}
                                </td>
                            </tr>}</>))}
                        </tbody>
                    </table>
                </div>
            </Grid>
            <Grid item container style={{ marginLeft: "10px" }} lg={9}>
                <div style={{ width: "100%", maxHeight: "530px", display: "block", overflowY: "auto", border: "1px solid #dce5ec", borderRadius: "9px" }}>
                    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <thead>
                            {/* Row 1: Exactly 1 cell stretching across 6 columns */}
                            <tr style={getRowStyle(0)}>
                                <th colSpan={6} style={cellStyleHeader}>
                                    <Grid item container>
                                        <span>Document Comparison</span>
                                        <span title={`${!showPartial ? "Contract" : "Expand"}`} style={{ marginLeft: "10px" }}>{showPartial ? <ExpandMoreIcon onClick={() => setShowPartial(!showPartial)} /> : <ExpandLessIcon onClick={() => setShowPartial(!showPartial)} />}</span>
                                    </Grid>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {details.map((row, rowIndex) => {
                                const actualRowIndex = rowIndex + 1;

                                return (
                                    <tr key={rowIndex} style={getRowStyle(actualRowIndex)}>
                                        {row.map((cellData, cellIndex) => (
                                            <>{showPartial ? <>{rowIndex < 6 && <td title={cellData} key={cellIndex} style={getCellStyle(cellIndex, rowIndex, cellData)}>
                                                <Grid item container flexWrap="nowrap">
                                                    {getCellLabel(cellIndex, rowIndex, cellData)}
                                                    {rowIndex == 0 && cellIndex > 0 && <span onClick={() => {
                                                        showJsonInNewTab(cellData);
                                                    }} style={{ paddingLeft: "8px", cursor: "pointer" }}><TocIcon /></span>}
                                                    {rowIndex == 0 && cellIndex > 0 && <span onClick={() => {
                                                        showErrorsInNewTab(cellData);
                                                    }} style={{ paddingLeft: "8px", cursor: "pointer", color: "#c53b3b" }}><ReportIcon /></span>}
                                                </Grid>
                                            </td>}</> : <td title={cellData} key={cellIndex} style={getCellStyle(cellIndex, rowIndex, cellData)}>
                                                <Grid item container flexWrap="nowrap">
                                                    {getCellLabel(cellIndex, rowIndex, cellData)}
                                                    {rowIndex == 0 && cellIndex > 0 && <span onClick={() => {
                                                        showJsonInNewTab(cellData);
                                                    }} style={{ paddingLeft: "8px", cursor: "pointer" }}><TocIcon /></span>}
                                                    {rowIndex == 0 && cellIndex > 0 && <span onClick={() => {
                                                        showErrorsInNewTab(cellData);
                                                    }} style={{ paddingLeft: "8px", cursor: "pointer", color: "#c53b3b" }}><ReportIcon /></span>}
                                                </Grid>
                                            </td>}</>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Grid>
        </Grid>
    );
}


export default CustomsUIError;